// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/intakeCompletionState.ts

/**
 * CN-R41E — detect completed Intake vs saved draft awaiting re-completion.
 * Uses case-detail `intakeAnswers` / `intakeDraft` shapes (not workflow status).
 */

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

/** Authoritative completed IntakeAnswersJson is present. */
export function hasCompletedNavigatorIntake(
  intakeAnswers: unknown
): boolean {
  return isPlainObject(intakeAnswers);
}

/** Incomplete IntakeDraftStateJson.draft payload is present. */
export function hasPendingIntakeDraft(intakeDraft: unknown): boolean {
  return isPlainObject(intakeDraft);
}

/**
 * Previously completed Intake with a newer saved draft that has not been
 * promoted by Complete Intake yet.
 */
export function hasSavedDraftAwaitingCompletion(
  intakeAnswers: unknown,
  intakeDraft: unknown
): boolean {
  return (
    hasCompletedNavigatorIntake(intakeAnswers) &&
    hasPendingIntakeDraft(intakeDraft)
  );
}
